import { Skeleton } from '@mui/material'
import { BoundaryThumbnailProps } from './types'
import { useThumbnailData } from './useThumbnailData'

export const BoundaryThumbnail = ({ boundary, ...imgProps }: BoundaryThumbnailProps) => {
  const imageData = useThumbnailData({ boundary, ...imgProps })

  if (!imageData.data || !boundary) return <Skeleton {...imgProps} />

  return <img alt={boundary.name} src={imageData.data} {...imgProps} />
}
